import { render, staticRenderFns } from "./GroupsNav.vue?vue&type=template&id=1403c221&"
import script from "./GroupsNav.vue?vue&type=script&lang=js&"
export * from "./GroupsNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports